// Pure math for the free Seller Net Sheet. No imports from anywhere else —
// deliberately duplicated from the broker analyzer's math patterns, not reused.

const n = (v) => {
  const parsed = Number(v);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function computeNetSheet(inputs) {
  const gross = n(inputs.sale_price);
  const commissionRate = n(inputs.commission_rate);
  const commissionAmount = gross * (commissionRate / 100);

  const items = [
    { key: 'commission', label: 'Total commission', amount: commissionAmount },
    { key: 'loan_payoff', label: 'Loan payoff', amount: n(inputs.loan_payoff) },
    { key: 'concessions', label: 'Seller concessions to buyer', amount: n(inputs.concessions) },
    { key: 'title_escrow', label: 'Title & escrow fees', amount: n(inputs.title_escrow) },
    { key: 'recording', label: 'Recording fees', amount: n(inputs.recording) },
    { key: 'transfer_tax', label: 'Transfer tax / doc stamps', amount: n(inputs.transfer_tax) },
    { key: 'prorated_taxes', label: 'Prorated property taxes', amount: n(inputs.prorated_taxes) },
    { key: 'hoa', label: 'HOA transfer / estoppel fees', amount: n(inputs.hoa) },
    { key: 'warranty', label: 'Home warranty for buyer', amount: n(inputs.warranty) },
    { key: 'staging', label: 'Staging costs', amount: n(inputs.staging) },
    { key: 'other', label: 'Other costs', amount: n(inputs.other) },
  ];

  const breakdown = items.filter((it) => it.amount !== 0);
  const totalDeductions = items.reduce((s, it) => s + it.amount, 0);
  const netProceeds = gross - totalDeductions;

  return { gross, commissionAmount, totalDeductions, netProceeds, breakdown };
}

export function fmtUSD(num, opts = {}) {
  const { cents = false } = opts;
  if (num == null || Number.isNaN(num)) return '—';
  const abs = Math.abs(num);
  const str =
    '$' +
    abs.toLocaleString('en-US', {
      minimumFractionDigits: cents ? 2 : 0,
      maximumFractionDigits: cents ? 2 : 0,
    });
  return (num < 0 ? '−' : '') + str;
}
